__turbopack_context__.v({
  "root": "kUatKa_root",
  "shippingLabelFadeIn": "kUatKa_shippingLabelFadeIn",
});
